import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { EmailReservationService } from '../../core/services/email-reservation.service';
import { EmailContentService } from '../../core/services/email-content.service';
import { StudioService } from '../../core/services/studio.service';

@Component({
    selector: 'app-email-reservation-edit',
    imports: [RouterLink, FormsModule],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i> 配信予約 / 編集</span>
    </div>
    <div class="card-body">
      @if (loading) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (!loading) {
        <form novalidate>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">文面 <span class="text-danger">*</span></label>
            <div class="col-sm-5">
              <select class="form-control" [(ngModel)]="form.emailContentId" name="emailContentId">
                <option [ngValue]="null">-- 選択してください --</option>
                @for (c of emailContents; track c.id) {
                  <option [ngValue]="c.id">{{ c.subject }}</option>
                }
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">配信予定日時 <span class="text-danger">*</span></label>
            <div class="col-sm-4">
              <input type="datetime-local" class="form-control" [(ngModel)]="form.scheduledAt" name="scheduledAt">
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-3 col-form-label">対象店舗</label>
            <div class="col-sm-5">
              <select class="form-control" [(ngModel)]="form.studioId" name="studioId">
                <option [ngValue]="null">全店舗</option>
                @for (s of studios; track s.id) {
                  <option [ngValue]="s.id">{{ s.name }}</option>
                }
              </select>
            </div>
          </div>
          <hr>
          <div class="form-group row">
            <div class="col-sm-9 offset-sm-3">
              <button type="button" class="btn btn-primary text-white" (click)="save()" [disabled]="saving || !form.emailContentId || !form.scheduledAt">
                <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
              </button>
              <a class="btn btn-secondary ml-2" routerLink="/email/reservation">キャンセル</a>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
  `
})
export class EmailReservationEditComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private emailReservationService = inject(EmailReservationService);
  private emailContentService = inject(EmailContentService);
  private studioService = inject(StudioService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  form: any = { emailContentId: null, studioId: null };
  emailContents: any[] = [];
  studios: any[] = [];
  loading = true;
  saving = false;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('配信予約', 'schedule_send', true);
    const id = +this.route.snapshot.params['id'];
    try {
      const [allReservations, contents, studioList] = await Promise.all([
        this.emailReservationService.get(),
        this.emailContentService.get(),
        this.studioService.list('all'),
      ]);
      const all: any[] = (allReservations as any[]) ?? [];
      this.form = all.find(r => r.id === id) ?? { id, emailContentId: null, studioId: null };
      if (this.form.scheduledAt) {
        this.form.scheduledAt = this.form.scheduledAt.slice(0, 16);
      }
      this.emailContents = (contents as any[]) ?? [];
      this.studios = (studioList as any[]) ?? [];
    } finally {
      this.loading = false;
    }
  }

  async save(): Promise<void> {
    if (!this.form?.emailContentId || !this.form?.scheduledAt) return;
    this.saving = true;
    try {
      await this.emailReservationService.upsert(this.form);
      this.router.navigate(['/email/reservation']);
    } finally {
      this.saving = false;
    }
  }
}
